/**
 * Products Slider Widget JS
 *
 * @since   1.0.0
 * @package premier
 */
(function($) {
    // Hook for when elementor front end is loaded
    $(window).on('elementor/frontend/init', function() {
        //hook name is 'frontend/element_ready/{widget-name}.{skin}
        //$scope is a jquery wrapped parent element
        elementorFrontend.hooks.addAction('frontend/element_ready/products-slider.default', function($scope) {


            if (window.innerWidth < 1100) {
                $('.products-slider').flickity({
                    cellAlign: 'left',
                    contain: true,
                    prevNextButtons: false,
                    wrapAround: true,
					freeScroll: true,
					freeScrollFriction: 0.03
                });
            }

            function handleFlickity() {
                if (window.innerWidth < 1100) {
                    if ($('.products-slider').hasClass('flickity-enabled')) {
                        return;
                    } else {
                        $('.products-slider').flickity({
                            cellAlign: 'left',
                            contain: true,
                            prevNextButtons: false,
                            wrapAround: true,
							freeScroll: true,
							freeScrollFriction: 0.03
                        });
                    }

                } else {
                    if ($('.products-slider').hasClass('flickity-enabled')) {
                        $('.products-slider').flickity('destroy');
                    }
                }
            }

            $(window).resize(handleFlickity);

        });
    });

})(jQuery);
